export const environment = {
  production: true,
  envName: 'production',
  // apiurl:'',
  apiurl:'/api',
  s3Url: 'https://s3.amazonaws.com/monitortech-reports/',
  url :{
  			dev: 'http://monitortech.dev',
  			test: 'https://tst-monitortech.idigiapps.com',
  			prod: 'https://www.mysilotrackcloud.com'
  		}
};
